export const REASON_DESCRIPTION_LABELS = {
  GHARZ_AND_DION: "پرداخت قرض و تادیه دیون (قرض الحسنه٫ بدهی و ...)",
  OMUMI: "هزینه عمومی و امور روزمره",
  NAGHDINEGI: "مدیریت نقدینگی",
  KALA: "خرید کالا",
  KHADAMAT: "خرید خدمات",
  ARZ: "امور ارزی",
  HOGHOGH: "واریز حقوق",
  BIME: "امور بیمه خدمات",
  DARMANI: "امور درمانی",
  BOURS: "امور سرمایه گذاری و بورس",
  BAZNESHASTEGI: "امور بازنشستگی",
  MOAMELAT_MANGHOL: "معاملات اموال منقول",
  MOAMELAT_GHEIR_MANGHOOL: "معاملات اموال غیر منقول",
  GOMROK: "عوارض گمرکی",
  MALIAT: "تسویه مالیاتی",
  DOWLATI: "سایر خدمات دولتی",
  TASHILAT: "بازپرداخت تسهیلات",
  VASIGHE: "تودیع وثیقه",
  KHEIRIEH: "کمک های نقدی و خیریه",
};

export function buildReasonDescriptionOptions(placeholder = "انتخاب بابت") {
  return [
    { text: placeholder, value: null },
    ...Object.entries(REASON_DESCRIPTION_LABELS).map(([value, text]) => ({
      text,
      value,
    })),
  ];
}

export function getReasonDescriptionLabel(value) {
  if (value == null || value === "") {
    return null;
  }

  const key = String(value).toUpperCase();
  return REASON_DESCRIPTION_LABELS[key] || String(value);
}
